import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    title: String,
    message: String,
    confirmLabel: { type: String, default: "Confirmer" },
    cancelLabel: { type: String, default: "Annuler" },
    variant: { type: String, default: "danger" },
    inputName: String,
    inputLabel: String,
    inputPlaceholder: String,
    inputRequired: { type: Boolean, default: false }
  }

  confirm(event) {
    event.preventDefault()
    event.stopPropagation()

    this.form = event.target.closest("form")
    this.showModal()
  }

  showModal() {
    const confirmColorClass = this.variantValue === "success"
      ? "bg-emerald-600 hover:bg-emerald-700 focus:ring-emerald-500"
      : "bg-red-600 hover:bg-red-700 focus:ring-red-500"

    const hasInput = this.hasInputNameValue && this.inputNameValue.length > 0
    const inputHtml = hasInput ? `
      <div class="mb-6">
        ${this.inputLabelValue ? `<label for="confirm-modal-input" class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">${this.escapeHtml(this.inputLabelValue)}${this.inputRequiredValue ? ' <span class="text-red-600">*</span>' : ''}</label>` : ""}
        <textarea id="confirm-modal-input" rows="3"
          class="w-full rounded border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="${this.escapeHtml(this.inputPlaceholderValue)}"></textarea>
      </div>
    ` : ""

    this.backdrop = document.createElement("div")
    this.backdrop.className = "fixed inset-0 z-50 flex items-center justify-center bg-black/50 transition-opacity"
    this.backdrop.setAttribute("aria-modal", "true")
    this.backdrop.setAttribute("role", "dialog")
    this.backdrop.innerHTML = `
      <div class="bg-white dark:bg-slate-800 rounded-lg shadow-xl w-full max-w-md mx-4 p-6 relative">
        <h3 class="text-lg font-bold mb-2">${this.escapeHtml(this.titleValue)}</h3>
        <p class="text-sm text-gray-600 dark:text-gray-300 mb-4">${this.escapeHtml(this.messageValue)}</p>
        ${inputHtml}
        <div class="flex justify-end gap-2">
          <button type="button" data-action="cancel"
            class="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-gray-500">
            ${this.escapeHtml(this.cancelLabelValue)}
          </button>
          <button type="button" data-action="confirm"
            class="${confirmColorClass} text-white font-semibold py-2 px-4 rounded focus:outline-none focus:ring-2">
            ${this.escapeHtml(this.confirmLabelValue)}
          </button>
        </div>
      </div>
    `

    this.backdrop.addEventListener("click", (e) => {
      if (e.target === this.backdrop) this.closeModal()
      if (e.target.dataset.action === "cancel") this.closeModal()
      if (e.target.dataset.action === "confirm") this.submitForm()
    })

    document.addEventListener("keydown", this.handleKeydown)
    document.body.appendChild(this.backdrop)

    if (hasInput) {
      const textarea = this.backdrop.querySelector("#confirm-modal-input")
      if (textarea) textarea.focus()
    }
  }

  handleKeydown = (e) => {
    if (e.key === "Escape") this.closeModal()
  }

  submitForm() {
    if (this.hasInputNameValue && this.inputNameValue.length > 0 && this.backdrop) {
      const textarea = this.backdrop.querySelector("#confirm-modal-input")
      const value = textarea ? textarea.value.trim() : ""
      if (this.inputRequiredValue && value.length === 0) {
        if (textarea) {
          textarea.classList.add("border-red-500", "ring-1", "ring-red-500")
          textarea.focus()
        }
        return
      }
      if (this.form) {
        const existing = this.form.querySelector(`input[type="hidden"][data-confirm-modal-input="true"]`)
        if (existing) existing.remove()
        const hidden = document.createElement("input")
        hidden.type = "hidden"
        hidden.name = this.inputNameValue
        hidden.value = value
        hidden.dataset.confirmModalInput = "true"
        this.form.appendChild(hidden)
      }
    }
    this.closeModal()
    if (this.form) this.form.requestSubmit()
  }

  closeModal() {
    document.removeEventListener("keydown", this.handleKeydown)
    if (this.backdrop) {
      this.backdrop.remove()
      this.backdrop = null
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
